export const RESOLUTION_STATUS = {
  CONSULTED: "Consulted",
  STATUS_CHANGED: "StatusChanged",
  REASON_CHANGED: "ReasonChanged"
};

export const COMPLIANCE_REVIEW_STATUS = {
  PENDING: "Pending",
  COMPLETED: "Completed"
};

export const FILTER_OPTIONS = {
  COMPANY_NAME: "CompanyName",
  PROJECT_NAME: "ProjectName",
  IDENT_ID: "IdentId"
};
